module.exports = __webpack_public_path__ + "media/src/website/images/partners/beachsalz-b2c33a246bf8628afdfd56768f2e8f0e.jpg";